var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2764(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA5A47",
    d: "M59.5 25c0-6.904-5.596-12.5-12.5-12.5a12.497 12.497 0 00-11 6.56 12.497 12.497 0 00-11-6.56c-6.904 0-12.5 5.596-12.5 12.5 0 2.97 1.04 5.694 2.77 7.839l-.004.003L36 58.54l20.734-25.698-.004-.003A12.44 12.44 0 0059.5 25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M59.5 25c0-6.904-5.596-12.5-12.5-12.5a12.497 12.497 0 00-11 6.56 12.497 12.497 0 00-11-6.56c-6.904 0-12.5 5.596-12.5 12.5 0 2.97 1.04 5.694 2.77 7.839l-.004.003L36 58.54l20.734-25.698-.004-.003A12.44 12.44 0 0059.5 25z"
  })));
}
export default Svg2764;